
@switch (type) {
  @case (PreviewMediaType.Image) {
    <img [src]="src">
  }
  @case (PreviewMediaType.YouTube) {
    <youtube-player [videoId]="src"></youtube-player>
  }
}
